module.exports = __webpack_public_path__ + "img/BookmarkIcon.3a66234b.svg";